module.exports = __webpack_public_path__ + "static/img/60-1.c76462b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/60-1.jpg
// module id = djGM
// module chunks = 0